import { useParams, Link, Navigate } from "react-router-dom";
import { INDUSTRIES } from "../lib/content";
import { ArrowUpRight, Check, ArrowLeft } from "lucide-react";
import CTABanner from "../components/CTABanner";
import { motion } from "framer-motion";

export default function IndustryDetail() {
  const { id } = useParams();
  const industry = INDUSTRIES.find((i) => i.id === id);
  if (!industry) return <Navigate to="/industries" replace />;

  return (
    <div data-testid={`industry-detail-${industry.id}`}>
      <section className="relative pt-40 pb-20 bg-[#0A1F3F] text-white overflow-hidden">
        <img src={industry.image} alt="" className="absolute inset-0 w-full h-full object-cover opacity-40" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A1F3F]/95 via-[#0A1F3F]/75 to-[#0A1F3F]/40" />
        <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-12">
          <Link
            to="/industries"
            className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] text-white/70 hover:text-white"
            data-testid="industry-back-link"
          >
            <ArrowLeft className="w-4 h-4" /> All industries
          </Link>
          <div className="mt-6 flex items-center gap-3">
            <span className="w-10 h-px bg-[#F37021]" />
            <span className="text-eyebrow text-[#F37021]">Industry {industry.number}</span>
          </div>
          <h1 className="mt-4 font-display font-black uppercase tracking-tighter text-5xl sm:text-6xl lg:text-7xl leading-[0.96] max-w-4xl">
            {industry.title}
          </h1>
          <p className="mt-6 text-base sm:text-lg text-white/85 max-w-2xl leading-relaxed">
            {industry.description}
          </p>
        </div>
      </section>

      <section className="py-24 sm:py-28 bg-white">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-7">
            <div className="relative aspect-[16/10] overflow-hidden bg-[#0A1F3F]">
              <img src={industry.image} alt={industry.title} className="w-full h-full object-cover" />
            </div>
          </div>
          <div className="lg:col-span-5">
            <div className="text-eyebrow text-[#F37021] mb-4">Overview</div>
            <p className="text-lg text-[#0A1F3F] leading-relaxed">{industry.longDescription}</p>

            <div className="mt-10">
              <div className="text-eyebrow text-[#F37021] mb-4">Key Products &amp; Services</div>
              <ul className="space-y-3">
                {industry.keyItems.map((k, i) => (
                  <motion.li
                    key={k}
                    initial={{ opacity: 0, x: -10 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: i * 0.05 }}
                    className="flex items-center gap-3 text-[#0A1F3F]"
                  >
                    <span className="w-6 h-6 bg-[#0A1F3F] text-white flex items-center justify-center">
                      <Check className="w-3 h-3" />
                    </span>
                    <span className="text-sm">{k}</span>
                  </motion.li>
                ))}
              </ul>
            </div>

            <Link
              to={`/quote?industry=${encodeURIComponent(industry.title)}`}
              data-testid={`industry-quote-cta-${industry.id}`}
              className="mt-10 inline-flex items-center gap-3 bg-[#F37021] hover:bg-[#D35F16] text-white px-8 py-5 text-xs uppercase tracking-[0.2em] font-semibold transition-colors"
            >
              Request Quote
              <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>

      <CTABanner />
    </div>
  );
}
